import {
  Checkbox,
  CircularProgress,
  FormControlLabel,
  IconButton,
  Tooltip,
  Typography,
} from '@material-ui/core'
import { ReplayOutlined } from '@material-ui/icons'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useAppDispatch } from 'store/configureStore'
import { fetchProjectSummaries } from 'store/ProjectList/asyncActions/fetchProjectSummaries'

export function ProjectsPageHelpers(props: {
  onlyMyProjects: boolean
  handleOnlyMyProjects: (filterMyProjects: boolean) => void
  handleReload?: () => void
  reloading?: boolean
}) {
  const { t } = useTranslation()
  const dispatch = useAppDispatch()

  return (
    <div className="helpers">
      <Tooltip
        title={t(
          'common:my-projects-filter-tooltip',
          'show projects where my user is the author or the sales representative'
        )}
        arrow
      >
        <FormControlLabel
          onClick={(e) => e.stopPropagation()}
          control={
            <Checkbox
              checked={props.onlyMyProjects}
              onChange={(e) => {
                e.preventDefault()
                props.handleOnlyMyProjects(e.target.checked)
              }}
              size="small"
            />
          }
          label={
            <Typography variant="body2">
              {t('common:my-projects', 'my projects')}
            </Typography>
          }
        />
      </Tooltip>
      <IconButton
        size="small"
        onClick={() =>
          props.handleReload
            ? props.handleReload()
            : dispatch(fetchProjectSummaries({ subscribeToUpdates: false }))
        }
        disabled={props.reloading}
      >
        {props.reloading ? <CircularProgress size={16} /> : <ReplayOutlined />}
      </IconButton>
    </div>
  )
}
